import { useContext, useEffect } from 'react';
import { SiteSettingsContext } from '@namespace/cms';
import { useDeviceStore } from '@namespace/device';
import { useI18n } from '@namespace/i18n';
import { useGetUserSegments } from '@namespace/segments';
import { useUserInfoLoaded } from '@namespace/user';
import { IS_USE_PLEX_API } from '../../constants';
import {
  gamesStoreActions,
  useGamesFeed,
  useGamesIsLoaded,
  useGamesStore,
  useGetLobby
} from '../../store';
import { useGetPlatformForFeed } from '../useGetPlatformForFeed';

const {
  SET_IS_FEED_LOADING,
  GET_GAMES,
  PLEX_GET_CATEGORIES,
  SET_IS_PLEX_CATEGORIES_LOADING
} = gamesStoreActions;

const useLoadCasinoFeedOld = ({ feedNames = '', condition = true }) => {
  const feeds = useGamesStore('feeds');

  const { isDesktop } = useDeviceStore();

  const { isLoading, isLoaded } = feeds[feedNames] || {};
  const platform = useGetPlatformForFeed();
  const isGamesLoaded = useGamesIsLoaded(feedNames, platform);
  const [settings] = useContext(SiteSettingsContext);
  const { casino = {} } = settings;
  const { disabledProviders = [] } = casino;
  const { userSegmentsNames: userSegments } = useGetUserSegments();
  const { userInfoLoaded } = useUserInfoLoaded();

  useEffect(() => {
    if (
      condition &&
      !isGamesLoaded &&
      feedNames &&
      !isLoading &&
      userInfoLoaded
    ) {
      SET_IS_FEED_LOADING(true, feedNames);
      GET_GAMES({
        disabledProviders,
        feedNames,
        platform,
        userSegments
      });
    }
  }, [
    condition,
    isGamesLoaded,
    disabledProviders.join('/'),
    feedNames,
    isDesktop,
    isLoading,
    userSegments,
    userInfoLoaded
  ]);

  return { isLoading, isLoaded };
};

const useLoadFeedCategories = ({
  feedNames: feedName = '',
  casinoType,
  limit = 36,
  condition = true
}) => {
  const { isDesktop } = useDeviceStore();
  const { isCategoriesLoading, isCategoriesLoaded } =
    useGetLobby(casinoType) || {};
  const { isLoading: isFeedLoading, isLoaded: isFeedLoaded } =
    useGamesFeed(feedName) || {};
  const platform = useGetPlatformForFeed();
  // TODO logic for disabledProviders ?
  // const [settings] = useContext(SiteSettingsContext);
  // const { casino = {} } = settings;
  // const { disabledProviders = [] } = casino;
  const { language } = useI18n();
  const { userSegmentsNames: userSegments } = useGetUserSegments();
  // const { userInfoLoaded } = useUserInfoLoaded();

  const isLoading =
    (casinoType && isCategoriesLoading) || (!casinoType && isFeedLoading);
  const isLoaded =
    (casinoType && isCategoriesLoaded) || (!casinoType && isFeedLoaded);

  useEffect(() => {
    // need to start waiting also for userInfoLoaded when actually start using userSegments with plex
    if (condition && feedName && !isLoading && !isLoaded) {
      if (casinoType) {
        SET_IS_PLEX_CATEGORIES_LOADING(true, casinoType);
      } else {
        SET_IS_FEED_LOADING(true, feedName);
      }
      PLEX_GET_CATEGORIES({
        feedName,
        filter: { limit },
        platform,
        lang: language,
        userSegments,
        casinoType
      });
    }
  }, [
    condition,
    feedName,
    isDesktop,
    userSegments,
    platform,
    casinoType,
    limit,
    language,
    isLoading,
    isLoaded
  ]);

  return { isLoading, isLoaded };
};

export const useLoadCasinoFeed = IS_USE_PLEX_API
  ? useLoadFeedCategories
  : useLoadCasinoFeedOld;
